module.exports = __webpack_public_path__ + "img/OM.58ae4f61.png";